import { dm_doi_tuong_tuyen_sinh } from "../../../models/response/category/dm_doi_tuong_tuyen_sinh";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const objDoiTuongTuyenSinhDefine = {
    LOAD_START: 0,
    LOAD_SUCCESS: [] as dm_doi_tuong_tuyen_sinh[],
    LOAD_ERROR: "",
    SHOW_EDIT_MODAL: {} as dm_doi_tuong_tuyen_sinh | undefined,
    CLOSE_EDIT_MODAL: undefined,
    SAVE_START: {} as dm_doi_tuong_tuyen_sinh,
    SAVE_SUCESS: {} as dm_doi_tuong_tuyen_sinh,
    SAVE_ERROR: "",
    DELETE_START: 0,
    DELETE_SUCESS: undefined,
    DELETE_ERROR: ""
};

export const eDoiTuongTuyenSinhActionTypeIds = generateActionTypeIds(objDoiTuongTuyenSinhDefine, "DOI_TUONG_TUYEN_SINH")
export type IDoiTuongTuyenSinhActionTypes = IGenericActionType<typeof objDoiTuongTuyenSinhDefine, "DOI_TUONG_TUYEN_SINH">
